import loadable from "@loadable/component";
import StatusIcon from "../../Icons/StatusIcon";
import usePatchHook from "../../customHooks/usePatchHook";
import APIS from "../../constant/EndPoint";

const ProductTypeListListComponent = loadable(
  () => import("../../components/ProductType/ProductTypeList")
);

const ProductTypeList = () => {
  const { mutateAsync: patchUser } = usePatchHook({ queryKey: ["product-types"], navigateURL: null })

  const handleIsRateType = async (value: boolean, id: any) => {
    const payload = {
      is_rate_by_weight: value
    };
    const url = `${APIS.PRODUCT_TYPE}${id}/`;
    const formData = payload
    try {
      await patchUser({ url, formData });

    } catch (e) {
      console.log(e)
    }
  }
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <StatusIcon />
        <span className="text-[#5E5757] font-bold text-xl">Product Type</span>
      </div>
      <ProductTypeListListComponent
      handleIsRateType={handleIsRateType}
      />
    </>
  );
};

export default ProductTypeList;
